import React from "react";
import PropTypes from "prop-types";
import Typography from "@material-ui/core/Typography";

const SubTitle = props => {
  return (
    <Typography
      style={props.style}
      component="h4"
      variant="h6"
      color="textSecondary"
      gutterBottom
    >
      {props.children}
    </Typography>
  );
};

SubTitle.propTypes = {
  children: PropTypes.node
};

export default SubTitle;
